import { Outlet } from "react-router-dom";
import { useSelector } from "react-redux";

const PrivateRoutes = ({ allowedRoles }) => {
  const auth = useSelector((state) => state.auth);

  if (
    allowedRoles &&
    allowedRoles.length > 0 &&
    !auth.roles?.some((role) => allowedRoles.includes(role))
  ) {
  }

  return <Outlet />;
};

export default PrivateRoutes;
